<template>
  <div class="col-md-6">
    <previous-names :report="report"></previous-names>
    <parent-companies :report="report"></parent-companies>
    <subsidiary-companies :report="report"></subsidiary-companies>
    <shareholding :report="report"></shareholding>
  </div>
</template>

<script>
import toolsMixin from '@/components/reports/ToolsMixin';
import PreviousNames from '@/components/reports/panels/PreviousNames';
import ParentCompanies from '@/components/reports/panels/ParentCompanies';
import SubsidiaryCompanies from '@/components/reports/panels/SubsidiaryCompanies';
import Shareholding from '@/components/reports/panels/Shareholding';

export default {
  components: {
    PreviousNames,
    ParentCompanies,
    SubsidiaryCompanies,
    Shareholding,
  },
  mixins: [toolsMixin],
  props: ['report'],
};
</script>

<style></style>
